import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=76999b0f&"
import script from "./Admin.vue?vue&type=script&lang=ts&"
export * from "./Admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76999b0f')) {
      api.createRecord('76999b0f', component.options)
    } else {
      api.reload('76999b0f', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=76999b0f&", function () {
      api.rerender('76999b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/Admin.vue"
export default component.exports